module.exports = __webpack_public_path__ + "resources/img/img_passxpertv4_5_en.658f9dec63d1e80dcdb9e474af69492d.png";